import { Component, OnInit, Inject } from "@angular/core";
import { Meta, Title } from "@angular/platform-browser";
import { MatDialog } from "@angular/material";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { SharedService } from "../shared/shared.service";
import { PlanDetailsService } from "./plan-details.service";
import { CheckAvailabilityService } from "../check-availability/check-availability.service";
import { LocalStorageService } from "angular-2-local-storage";
import { SESSION_STORAGE, WebStorageService } from "angular-webstorage-service";
import { FormControl, Validators, ReactiveFormsModule } from "@angular/forms";
import { FirstLetterUpperCase } from "../shared/pipe/firstletteruppercase.pipe";
import { LowerCasePipe } from "@angular/common";
import { Observable } from "rxjs/Observable";
import { DataSource } from "@angular/cdk/collections";
import "rxjs/add/observable/of";
import { LoggerService } from "app/logger/logger.service";
import { TDUModel } from "../shared/models/shared-models";

// global variable
declare var google;

const ZIPCODE_REGEX = /^[0-9]{5}(?:-[0-9]{4})?$/;

@Component({
	selector: "app-plan-details",
	templateUrl: "./plan-details.component.html",
	styleUrls: ["./plan-details.component.css"],
	providers: [LowerCasePipe],
})
export class PlanDetailsComponent implements OnInit {
	// validation field required
	serviceAddressFormControl = new FormControl("", [Validators.required]);
	apartmentFormControl = new FormControl("", [Validators.required]);

	displayedColumns = ["AverageMonthlyUse", "500kWh", "1000kWh", "2000kWh"];
	public detailedView: DetailedView;
	public show_more_detail: boolean;
	public show_more: string;
	public is_error_address: boolean;
	public is_error_address_yellow: boolean;
	public is_apt_exist: boolean;
	public isCompleteButtonDisabled: boolean;
	public error_address: string;
	public error_address_yellow: string;
	// public variable define
	public plan_rate: string;
	public plan_rate_autopay: string;
	public plan_detail: any = [];
	public service_address_obj: Object;
	public valid_enroll: boolean;
	public esiid: string;
	public esiid_flag: any;
	public zipcode: string;
	public is_exact_address: boolean;
	public error_message: string;
	public apt_units: any = [];
	public apt_unit: string;
	public apartment_list: any = [];
	public apartment_obs: Observable<string[]>;
	public is_loader: boolean;
	public ShowAddressLoader: boolean;
	public is_apt_loader: boolean;
	public duns: string;
	public old_key: number;
	public which_event: string;
	public places: any;
	public is_address_addlis: boolean;
	public search_val: any;
	public avgkwh500: string;
	public avgkwh1000: string;
	public avgkwh2000: string;
	public avgkwh500_autopay: string;
	public avgkwh1000_autopay: string;
	public avgkwh2000_autopay: string;
	public plan_name: string;
	public is_zipcode_diff: any;
	public tdus: Array<TDUModel> = [];
	public selectedTdu: TDUModel;
	public service_address_search = {};
	public service_address_array = [];

	public showAddressItems: boolean = false;
	public showAptItems: boolean = false;

	public showAutopayRateInfo: boolean = false;
	public autopayDiscount: number;
	public plan_allin_discounted: string;

	//These booleans allow us to replace the suggestions list with "Zip Code:xxxxx" when the user enters a zip code, and to extract the zip code from the input if the suggestion is selected
	public isZipCode: boolean = false;
	public isZipCodeSelected: boolean = false;
	public isSwitchHold: boolean = false;
	public hasPromotionHold: boolean = false;
	public hasBalanceHold: boolean = false;
	public hasHoldOverride: boolean = false;
	public hasSwitchHoldIndicator: boolean = false;
	public is_switchHold: boolean;
	public error_switchHold;

	public acceptNewEnrollments = true;

	public acceptCenterpoint = true;
	public acceptOncor  = true;
	public acceptAEPNorth = true;
	public acceptAEPCentral = true;
	public acceptTnmp = true;

	public isTduEnrollmentBlocked = false;

	private documents: any = {
		en: {
			EFL: "",
			TOS: "",
			PDS: "",
			YRAC: "",
		},
		es: {
			EFL: "",
			TOS: "",
			PDS: "",
			YRAC: "",
		},
	};

	constructor(
		private meta: Meta,
		private title: Title,
		private activatedRoute: ActivatedRoute,
		private router: Router,
		public dialog: MatDialog,
		private sharedService: SharedService,
		private logger: LoggerService,
		private service: CheckAvailabilityService,
		private planService: PlanDetailsService,
		private localStorageService: LocalStorageService,
		@Inject(SESSION_STORAGE) private sessionStorageService: WebStorageService,
		private firstLetterPipe: FirstLetterUpperCase,
		private lowerCasePipe: LowerCasePipe
	) {
		this.addUpdateMetaTags();

		this.sessionStorageService.remove("data_account");
		this.sessionStorageService.remove("data_personal");
		this.sessionStorageService.remove("data_service");
		this.sessionStorageService.remove("enrollment_process_start_date");
		let methodName = this.constructor.name + ".verifyToken";

		// User already logged in
		if (this.localStorageService.get("token") != null) {
			this.sharedService
				.verifyToken({ token: this.localStorageService.get("token") })
				.then(
					(res) => {
						let logObj = {
							method: methodName,
							request: "token : [masked]",
							response: res,
						};
						this.logger.logInfo(JSON.stringify(logObj));
						if (res.status === "success" && res.isTerminated === false) {
							this.router.navigate(["./dashboard"]);
						} else {
							this.localStorageService.remove("token");
							this.router.navigate(["./sign-in"]);
						}
					},
					(error) => {
						let logObj = {
							method: methodName,
							request: "token : [masked]",
							exception: error,
						};
						this.logger.logError(JSON.stringify(logObj));
					}
				)
				.catch((ex) => {
					let logObj = {
						method: methodName,
						request: "token : [masked]",
						exception: ex,
					};
					this.logger.logError(JSON.stringify(logObj));
				});
		}
		else {
			this.show_more_detail = false;
			this.show_more = "More Details";
			this.sharedService.setHeaderTitle("plan_detail");
			this.valid_enroll = false;
			this.esiid = "";
			this.zipcode = "";
			this.is_loader = true;
			this.sharedService.setLoader("plan_detail", true);
			this.plan_rate = "0.0";
			this.plan_rate_autopay = "0.0";
			this.autopayDiscount = 2.0;
			this.is_exact_address = false;
			this.apt_unit = "";
			this.which_event = "";
			this.is_address_addlis = false;
			this.avgkwh500 = "0";
			this.avgkwh1000 = "0";
			this.avgkwh2000 = "0";
			this.avgkwh500_autopay = "0";
			this.avgkwh1000_autopay = "0";
			this.avgkwh2000_autopay = "0";
			this.plan_name = "";
			this.is_zipcode_diff = false;

			this.sharedService.getElectricUtilityProviders().then(activeTdus => {

				this.tdus = activeTdus;

				this.activatedRoute.params.subscribe((params: Params) => {
					if (params["esiid"]) {
						this.esiid = params["esiid"];
						this.is_exact_address = true;
						this.valid_enroll = true;
					}
					if (params["zipcode"]) {
						this.zipcode = params["zipcode"];
						this.is_exact_address = false;
						this.valid_enroll = false;
					}

					let optionalTdu = '';
					if (params["tdu"]) {
						this.sessionStorageService.set("tdu", params["tdu"]);
						this.selectedTdu = this.tdus.find((x) => x.tduCode == params["tdu"]);
						optionalTdu = this.selectedTdu.tduCode;

						if (!this.acceptAEPNorth && this.selectedTdu.tduCode === 'AEP TNC') {
							this.isTduEnrollmentBlocked = true;
							console.log(this.isTduEnrollmentBlocked)
							return;
						}

						console.log(this.acceptAEPCentral, this.selectedTdu.tduCode)

						if (!this.acceptAEPCentral && this.selectedTdu.tduCode === 'AEP TCC') {
							this.isTduEnrollmentBlocked = true;
						}

						if (!this.acceptCenterpoint && this.selectedTdu.tduCode === 'Centerpoint') {
							this.isTduEnrollmentBlocked = true;
						}

						if (!this.acceptOncor && this.selectedTdu.tduCode === 'ONCOR') {
							this.isTduEnrollmentBlocked = true;
						}

						if (!this.acceptTnmp && this.selectedTdu.tduCode === 'TNMP') {
							this.isTduEnrollmentBlocked = true;
						}

						//
						//
						// if (!this.acceptTnmp || this.acceptOncor || !this.acceptAEPCentral || !this.acceptAEPNorth || !this.acceptCenterpoint) {
						// 	this.isTduEnrollmentBlocked = true;
						// }

						this.fetchAllDocuments(this.selectedTdu);
					}

					this.planService.getPlan({ esi_id: this.esiid, zipcode: this.zipcode, tdu: optionalTdu })
						.then((plan_detail) => {
							this.is_loader = true;
							const context = this;
							const is_enroll = this.valid_enroll;
							const timeout_value = 500;

							setTimeout(function () {
								if (is_enroll) {
									var element = document.getElementById("enroll_now");
									if (element !== undefined && element !== null) {
										document.getElementById("enroll_now").focus();
									}
								} else {
									let address_input =
										document.getElementById("service_address_id");
									if (address_input) {
										address_input.blur();
									}
								}
							}, timeout_value);

							if (plan_detail.status === "success") {
								if (plan_detail.result.length === 0) {
									this.router.navigate(["./service-not-available"]);
								}
								else {
									this.plan_detail = plan_detail;
									this.plan_rate = plan_detail.result[0]["price"];
									this.avgkwh500 = plan_detail.result[0]["kwh500"];
									this.avgkwh1000 = plan_detail.result[0]["kwh1000"];
									this.avgkwh2000 = plan_detail.result[0]["kwh2000"];
									this.plan_rate_autopay = plan_detail.result[0]["price_Autopay"];
									this.avgkwh500_autopay = plan_detail.result[0]["kwh500_Autopay"];
									this.avgkwh1000_autopay = plan_detail.result[0]["kwh1000_Autopay"];
									this.avgkwh2000_autopay = plan_detail.result[0]["kwh2000_Autopay"];
									this.plan_name = plan_detail.result[0]["displayProductName"];
									this.detailedView = new DetailedView(plan_detail.result);
									this.localStorageService.set("ProductID", 12);

									if (plan_detail.result[0]['serviceProvider']) {
										this.selectedTdu = this.tdus.find((x) => x.tduCode == plan_detail.result[0]['serviceProvider']);
										if (!this.acceptAEPNorth && this.selectedTdu.tduCode === 'AEP TNC') {
											this.isTduEnrollmentBlocked = true;
										}

										if (!this.acceptAEPCentral && this.selectedTdu.tduCode === 'AEP TCC') {
											this.isTduEnrollmentBlocked = true;
										}

										if (!this.acceptCenterpoint && this.selectedTdu.tduCode === 'Centerpoint') {
											this.isTduEnrollmentBlocked = true;
										}

										if (!this.acceptOncor && this.selectedTdu.tduCode === 'ONCOR') {
											this.isTduEnrollmentBlocked = true;
										}

										if (!this.acceptTnmp && this.selectedTdu.tduCode === 'TNMP') {
											this.isTduEnrollmentBlocked = true;
										}
									}

									if (this.esiid) {

										//plan was found and esiid not blank
										this.sessionStorageService.set("tdu", this.selectedTdu.tduCode);
										this.localStorageService.set("address_for_billing", this.plan_detail.ercotRecord[0]);
										this.localStorageService.set("esi_id", this.esiid);
										this.service_address_obj = this.localStorageService.get("address_for_billing");

										this.fetchAllDocuments(this.selectedTdu);

										let addressObj = this.service_address_obj;
										let address1 = (addressObj["streetAddress"] !== null ? addressObj["streetAddress"].toString() : "") + " " +
													   (addressObj["streetAddress"] !== null ? addressObj["streetAddress"].toString() : "");
										let address2 = addressObj["aptUnit"] !== null ? addressObj["aptUnit"].toString() : "";
										let city = addressObj["city"] !== null ? addressObj["city"].toString() : "";
										let state = addressObj["state"] !== null ? addressObj["state"].toString() : "";
										let zip = addressObj["zipcode"] !== null ? addressObj["zipcode"].toString() : "";

										var dataLayerEvent = "enroll - step 0.5";

										(window as any).dataLayer.push({
											event: dataLayerEvent,
											address1: address1,
											address2: address2,
											city: city,
											state: state,
											zip: zip,
											productID: 12, // plan_detail.result[0]['productId'].toString(),
											ESIID: this.esiid,
											TDU: this.selectedTdu.tduCode,
										});

										if (this.sharedService.SwitchHoldIndicator.value) {
											this.validateSwitchHoldIndicator(params["esiid"]);
										}

										return this.sharedService.validateAddress({ ercotId: addressObj["id"] })
									}
								}
							} else {
								if (plan_detail.sgflag) {
									this.router.navigate(["./page-not-found"]);
								} else {
									this.router.navigate(["./service-not-available"]);
								}
							}
						})
						.then((res) => {
							if (res) {
								if (res.status === "success") {
									this.is_error_address = false;
									this.is_error_address_yellow = false;
									if (
										this.apt_unit != null &&
										this.apt_unit !== ""
									) {
										this.is_apt_exist = true;
									}
									this.isCompleteButtonDisabled = true;
									this.hasSwitchHoldIndicator = false
								}
								else {
									if (res.color === "yellow") {
										this.is_error_address_yellow = true;
										this.error_address_yellow = res.message;
									}
									else {
										this.is_error_address = true;
										this.error_address = res.message;
										if (res.message === "Oops. We can’t complete your enrollment at this location because it seems to have a switch hold on it. You may need to do a little work to get started. If you’re moving to this address, please follow these instructions to release the switch hold at <a href=\"https://pogoenergy.com/switch-hold-removal\" target=\"_blank\">PogoEnergy.com/SHR</a>.  If you currently have service with another provider, please contact them to discuss your switch hold status.") {
											this.isSwitchHold = true;
											this.is_loader = false;
											this.sharedService.setLoader("plan_detail", false);
										}
									}
								}
							}
							this.is_loader = false;
							this.sharedService.setLoader("plan_detail", false);
							let body = document.body;
							body.click();
						})
						.catch((error) => {
							this.is_loader = false;
							this.sharedService.setLoader("plan_detail", false);
							const body = document.body;
							body.click();
						});
				});
			});
		}

		// Flag that enable / disable starting new enrollments
		this.sharedService.getConfigConst()
			.then(response => {
				if (response.status === 'success') {
					this.acceptNewEnrollments = response.results[0]['acceptNewEnrollments'];
					this.acceptCenterpoint = response.results[0]['acceptCenterpoint'];
					this.acceptOncor = response.results[0]['acceptOncor'];
					this.acceptAEPNorth = response.results[0]['acceptAEPNorth'];
					this.acceptAEPCentral = response.results[0]['acceptAEPCentral'];
					this.acceptTnmp = response.results[0]['acceptTnmp'];
				}
			});
	}

	navigateTo(url: string) {
		this.router.navigate([url]);
	}

	addUpdateMetaTags() {
		this.title.setTitle("Plans | Pogo Energy");
		const titleTag = this.meta.getTag("name=title");

		if (titleTag) {
			this.meta.updateTag({ name: "title", content: "Plans | Pogo Energy" });
		} else {
			this.meta.addTag({ name: "title", content: "Plans | Pogo Energy" });
		}

		const descriptionTag = this.meta.getTag("name=description");

		if (descriptionTag) {
			this.meta.updateTag({
				name: "description",
				content:
					"Choose no deposit electricity from Pogo Energy and you can save money and save the world. Save up to $300 a year with 100% clean energy. Same day power-on.",
			});
		} else {
			this.meta.addTag({
				name: "description",
				content:
					"Choose no deposit electricity from Pogo Energy and you can save money and save the world. Save up to $300 a year with 100% clean energy. Same day power-on.",
			});
		}

		const title1Tag = this.meta.getTag("name=title1");

		if (title1Tag) {
			this.meta.updateTag({ name: "title1", content: "No Deposit" });
		} else {
			this.meta.addTag({ name: "title1", content: "No Deposit" });
		}

		const description1Tag = this.meta.getTag("name=description1");

		if (description1Tag) {
			this.meta.updateTag({
				name: "description1",
				content:
					"No deposit electricity without the BS (bill shock). Save up to $300 a year with 100% clean energy. Cancel at any time without penalty.",
			});
		} else {
			this.meta.addTag({
				name: "description1",
				content:
					"No deposit electricity without the BS (bill shock). Save up to $300 a year with 100% clean energy. Cancel at any time without penalty.",
			});
		}

		const title2Tag = this.meta.getTag("name=title2");

		if (title2Tag) {
			this.meta.updateTag({ name: "title2", content: "100% Clean Energy " });
		} else {
			this.meta.addTag({ name: "title2", content: "100% Clean Energy " });
		}

		const description2Tag = this.meta.getTag("name=description2");

		if (description2Tag) {
			this.meta.updateTag({
				name: "description2",
				content:
					"100% clean, renewable energy from sustainable sources like solar and wind. Get clean energy with no deposit electricity and save up to $300 a year.",
			});
		} else {
			this.meta.addTag({
				name: "description2",
				content:
					"100% clean, renewable energy from sustainable sources like solar and wind. Get clean energy with no deposit electricity and save up to $300 a year.",
			});
		}
	}

	ngOnDestroy() {
		this.title.setTitle("Pogo Energy");
		const titleTag = this.meta.getTag("name=title");

		if (titleTag) {
			this.meta.updateTag({ name: "title", content: "Pogo Energy" });
		}

		const descriptionTag = this.meta.getTag("name=description");

		if (descriptionTag) {
			this.meta.updateTag({ name: "description", content: "" });
		}

		const title1Tag = this.meta.getTag("name=title1");
		if (title1Tag) {
			this.meta.removeTag("name=title1");
		}

		const title2Tag = this.meta.getTag("name=title2");
		if (title2Tag) {
			this.meta.removeTag("name=title2");
		}

		const description1Tag = this.meta.getTag("name=description1");
		if (description1Tag) {
			this.meta.removeTag("name=description1");
		}

		const description2Tag = this.meta.getTag("name=description2");
		if (description2Tag) {
			this.meta.removeTag("name=description2");
		}
	}

	fetchAllDocuments(selectedTdu : TDUModel) {
		this.planService
			.getDocumentByTDU("EFL", "English", selectedTdu.tduCode)
			.then((res) => {
				if (res && res.status == "success") {
					this.documents.en["EFL"] = res.result[0].documentUrl;
				}
			});

		this.planService
			.getDocumentByTDU("EFL", "Spanish", selectedTdu.tduCode)
			.then((res) => {
				if (res && res.status == "success") {
					this.documents.es["EFL"] = res.result[0].documentUrl;
				}
			});

		this.planService.getDocument("TOS", "English").then((res) => {
			if (res && res.status == "success") {
				this.documents.en["TOS"] = res.result[0].documentUrl;
			}
		});

		this.planService.getDocument("TOS", "Spanish").then((res) => {
			if (res && res.status == "success") {
				this.documents.es["TOS"] = res.result[0].documentUrl;
			}
		});

		this.planService.getDocument("PDS", "English").then((res) => {
			if (res && res.status == "success") {
				this.documents.en["PDS"] = res.result[0].documentUrl;
			}
		});

		this.planService.getDocument("PDS", "Spanish").then((res) => {
			if (res && res.status == "success") {
				this.documents.es["PDS"] = res.result[0].documentUrl;
			}
		});

		this.planService.getDocument("YRAC", "English").then((res) => {
			if (res && res.status == "success") {
				this.documents.en["YRAC"] = res.result[0].documentUrl;
			}
		});

		this.planService.getDocument("YRAC", "Spanish").then((res) => {
			if (res && res.status == "success") {
				this.documents.es["YRAC"] = res.result[0].documentUrl;
			}
		});
	}

	moreDetail() {
		if (this.show_more_detail === true) {
			this.show_more_detail = false;
		} else {
			this.show_more_detail = true;
		}
	}

	// view document of plan
	viewDocument(documentName: string) {
		let lang = document.getElementById("which_language").innerHTML;

		var urlObj;
		if (lang === "Spanish") {
			urlObj = this.documents.es;
		} else {
			urlObj = this.documents.en;
		}

		window.open(urlObj[documentName], "_blank");
	}

	validEnroll(address_val: any) {
		if (address_val.target.value === "") {
			this.valid_enroll = false;
		} else {
			this.valid_enroll = true;
		}
	}

	// validate apt or unit
	validateApt() {
		if (document.getElementById("enroll_now") !== undefined)
			document.getElementById("enroll_now").setAttribute("disabled", "");
		//this.apt_unit = '';
	}

	ngOnInit() {
		this.serviceAddressFormControl.valueChanges.subscribe((searchKey) => {
			if (searchKey && searchKey.trim() != "") {
				this.is_error_address_yellow = false;

				var to_match;
				if (this.isZipCodeSelected) {
					var temp = searchKey.split(" ");
					to_match = temp[2];
				} else {
					to_match = searchKey;
				}

				this.isZipCodeSelected = false;

				this.service.direct_search(searchKey).then((res) => {
					this.service_address_array = [];

					if (res && res["value"] && res["value"].length > 0 && !to_match.match(ZIPCODE_REGEX))
					{
						this.service_address_array = res["value"];
						this.isZipCode = false;
					}
					//adding else if and zipcode regex conditions
					else if (to_match.match(ZIPCODE_REGEX)) {
						this.service_address_array = [
							{
								address_full: "Zip Code: " + to_match,
							},
						];
						this.isZipCode = true;
					}

					setTimeout(() => {
						this.showAddressItems =
							this.service_address_array.length > 0 &&
							!this.isInAddressArray(searchKey);
					}, 100);

					if (this.service_address_array.length == 0 && !this.isZipCodeSelected) {
						this.is_error_address_yellow = true;
						this.error_address_yellow =	this.sharedService.getErrorMessage("address_not_found");
						this.isCompleteButtonDisabled = false;
					}
				});
			} else {
				this.service_address_array = [];
				this.showAddressItems = false;
			}
		});
	}

	get_service_array(options: any[]) {
		let service_array = [];
		for (let i = 0; i < options.length; i++) {
			let opt = options[i];
			let ser_opt = {
				text: this.get_high_suggest(opt._source.suggest),
				_id: opt._source.objectid,
			};
			service_array.push(ser_opt);
		}

		return service_array;
	}

	get_high_suggest(suggests: any[]) {
		let text = "";
		let maxLength = 0;
		for (let i = 0; i < suggests.length; i++) {
			let segg = suggests[i];
			if (segg.weight == 3) {
				return segg.input;
			}
		}
	}

	focusoutServiceAddress(service_address_search_text) {
		this.service_address_search["text"] = service_address_search_text;
		if (this.isZipCode) {
			this.isZipCodeSelected = true;
		}

		const context = this;
		setTimeout(() => {
			context.showAddressItems = false;
			let element = document.getElementById("service_address_id");
			if (element) {
				element.blur();
			}
		}, 200);
	}

	isInAddressArray(key: string) {
		let inArray: boolean = false;
		for (let i = 0; i < this.service_address_array.length; i++) {
			let arr_ele = this.service_address_array[i];
			if (arr_ele["address_full"].trim() == key.trim()) {
				inArray = true;
				break;
			}
		}
		return inArray;
	}

	isInAPtArray(key: string) {
		let inArray: boolean = false;
		for (let i = 0; i < this.apartment_list.length; i++) {
			let arr_ele = this.apartment_list[i];
			if (arr_ele.toString().trim() == key.trim()) {
				inArray = true;
				break;
			}
		}
		return inArray;
	}

	addressEvent(event) {
		this.is_error_address = false;
		this.is_error_address_yellow = false;
		this.is_apt_exist = false;
		this.isCompleteButtonDisabled = false;
		this.apt_unit = "";
		this.esiid = "";
		this.apartment_list = [];
		let event_value: string = event.target.value;

		if (!this.isZipCodeSelected) {
			event_value = event.target.value;
		} else {
			var temp = event.target.value;
			event_value = temp.split(" ")[2];
		}

		let address_hash = this.getHashFromAddress(event_value);

		const enter_key = event.keyCode || event.which;

		if (
			(event.type === "keyup" && enter_key === 13) ||
			(this.old_key === 17 && enter_key === 86) ||
			(this.old_key === 86 && enter_key === 17)
		) {
			this.sharedService.InvokeHtmlElementEvent("service_address_id", "blur");
		}

		if (address_hash && address_hash.trim() != "") {
			this.selectAddressHash(address_hash);
		}
		else if (event_value.match(ZIPCODE_REGEX)) {
			this.isCompleteButtonDisabled = false;
		}
		else {
			if (
				event_value &&
				event_value.trim() != "" &&
				this.service_address_array.length == 0
			) {
				this.is_error_address_yellow = true;
				this.error_address_yellow =
					this.sharedService.getErrorMessage("address_not_found");
				this.isCompleteButtonDisabled = false;
			}
		}

		this.old_key = enter_key;
	}

	getHashFromAddress(address: string) {
		for (let i = 0; i < this.service_address_array.length; i++) {
			let service_address = this.service_address_array[i];
			if (service_address["address_full"].trim() == address.trim()) {
				//return service_address._id;
				return service_address["FullAddressHashKey"];
			}
		}
		return "";
	}

	selectAddressHash(address_hash: string) {

		if (!address_hash || !address_hash) {
			this.isCompleteButtonDisabled = false;
			return;
		}

		if (address_hash.trim().length <= 5) {

		}

		this.ShowAddressLoader = true;

		let requestObj = {
			addressHash: address_hash.trim(),
		};

		this.service.GetServiceAddressesByHash(requestObj).then((res) => {

			if (res.result.length > 0) {
				this.apt_units = res.result;
				for (let i = 0; i < this.apt_units.length; i++) {
					if (
						this.apt_units[i].aptUnit != null &&
						this.apt_units[i].aptUnit !== ""
					) {
						let apartment = this.apt_units[i].aptUnit;
						this.apartment_list.push(apartment);
					}
				}

				this.is_apt_exist = this.apartment_list.length > 0;
				this.apartment_obs = this.apartmentFormControl.valueChanges
					.startWith(null)
					.map((val) =>
						val ? this.filter(val) : this.apartment_list.slice()
					);
				this.showAptItems = true;
				if (res.result.length === 1) {
					const address_obj = res.result[0];
					if (this.is_apt_exist) {
						this.apt_unit = this.apartment_list[0];
						this.chooseApartUnit(this.apt_unit, undefined);
					} else {
						this.chooseApartUnit("", address_obj);
						this.sharedService.InvokeHtmlElementEvent("enroll_now", "focus");
					}
				} else if (this.is_apt_exist) {
					if (this.apartment_list.length == 1) {
						this.apt_unit = this.apartment_list[0];
						this.chooseApartUnit(this.apt_unit, undefined);
					} else {
						const context = this;
						setTimeout(() => {
							context.sharedService.InvokeHtmlElementEvent("apartment", "focus");
						}, 100);
					}
				}
			}
			else {

				var dataLayerEvent = "enroll - step 0: address issue";
				(window as any).dataLayer.push({
					event: dataLayerEvent,
					"error address_hash": address_hash.trim(),
				});
				this.is_error_address_yellow = true;
				this.error_address_yellow =
					this.sharedService.getErrorMessage("address_not_found");
				this.isCompleteButtonDisabled = false;
			}

			this.ShowAddressLoader = false;
		});
	}

	aptUnitEvent(event) {
		const enter_key = event.keyCode || event.which;

		if ((event.type === "keyup" && enter_key === 13) ||
			(this.old_key === 17 && enter_key === 86) ||
			(this.old_key === 86 && enter_key === 17)) {
			this.sharedService.InvokeHtmlElementEvent("apartment", "blur");
		}

		this.old_key = enter_key;
	}

	scrollToHere(event) {
		let element = event.target;
		if (element !== undefined) {
			element.scrollIntoView();
			document.body.scrollTop = element.offsetTop;
		}
	}

	async chooseApartUnit(apt_number: string, address_obj: any) {
		if (
			(apt_number == undefined || apt_number.trim() == "") &&
			address_obj == undefined
		) {
			return;
		}
		this.showAptItems = false;
		if (apt_number !== "") {
			for (let i = 0; i < this.apt_units.length; i++) {
				let apartment = this.apt_units[i].aptUnit;

				if (apartment === apt_number) {
					address_obj = this.apt_units[i];
					this.apt_unit = apartment;
				}
			}
		}
		this.is_apt_loader = true;
		this.sharedService.InvokeHtmlElementEvent("enroll_now", "focus");

		this.duns = address_obj.duns;
		this.esiid = address_obj.esiId;
		this.localStorageService.set("address_for_billing", address_obj);
		this.localStorageService.set("esi_id", this.esiid);

		var response = await this.validateSwitchHoldIndicator(this.esiid);
		this.is_apt_loader = false;
		if (response.status != "success") {
			this.is_error_address = true;
			this.error_address = response.message;
		}
		else {
			this.isCompleteButtonDisabled = true;
		}

	}

	async showRequire() {
		if (!this.is_error_address) {
			if (this.isCompleteButtonDisabled) {
				this.sharedService.setLoader("plan_detail", true);
				await this.getHoldDetails(this.esiid);
				if (this.hasBalanceHold == true || this.hasPromotionHold == true) {
					if (this.hasHoldOverride == false) {
						this.sharedService.setLoader("plan_detail", false);
						this.router.navigate(['./enrollment-wizard/esiid-flagged']);
						return false;
					}
				}
				this.sharedService.setLoader("plan_detail", false);
				this.router.navigate(['./enrollment-wizard/account']);

				this.isZipCode = false;
				this.isZipCodeSelected = false;
				const len = document.getElementsByTagName('body')[0];
				len.click();
			}
		}

	}

	validateSwitchHoldIndicator(esiid: string) {
		return this.planService.validateSwitchHoldIndicator(esiid);
	}

	async getHoldDetails(esi_id: string) {
		await this.planService.getEsiIdHoldDetails(esi_id).then((res) => {
			if (res.balanceHold == true) {
				this.hasBalanceHold = true;
			}
			this.localStorageService.set("esi_id", esi_id);
			this.localStorageService.set("hasBalanceHold", this.hasBalanceHold);
			if (res.promotionHold == true) {
				this.hasPromotionHold = true;
			}
			this.localStorageService.set("hasPromotionHold", this.hasPromotionHold);
			if (res.hasOverride == true) {
				this.hasHoldOverride = true;
			}
			this.localStorageService.set("hasHoldOverride", this.hasHoldOverride);
		});
	}

	// apt autocomplete filter
	filter(val: string): string[] {
		setTimeout(() => {
			this.isCompleteButtonDisabled = false;
			let isInApt: boolean = this.isInAPtArray(val);
			this.showAptItems = this.apartment_list.length > 0 && !this.isCompleteButtonDisabled;
			if (isInApt) {
				this.chooseApartUnit(this.apt_unit, "");
			}
		}, 100);
		return this.apartment_list.filter(
			(option) => option.toLowerCase().indexOf(val.toLowerCase()) === 0
		);
	}

	NavigateTo(rout: string) {
		this.router.navigate(['./enroll']);
	}
}

@Component({
	// tslint:disable-next-line:component-selector
	selector: "view-efl-dialog1",
	templateUrl: "view-efl-dialog.html",
})
// tslint:disable-next-line:component-class-suffix
export class ViewEFL {
	constructor(
		private activatedRoute: ActivatedRoute,
		private router: Router,
		public dialog: MatDialog,
		private sharedService: SharedService,
		private planService: PlanDetailsService,
		private localStorageService: LocalStorageService
	) { }

	viewDocument(documentName: string) {
		let lang = document.getElementById("which_language").innerHTML;

		this.planService.getDocument(documentName, lang).then((res) => {
			if (res && res.status == "success") {
				window.open(res.result[0].documentUrl, "_blank");
			}
		});
	}
}

export interface DetailedView {
	month: string;
	charges: string;
	credits: string;
	balance: string;
}

export class DetailedView extends DataSource<any> {
	public data: DetailedView[];
	constructor(private elementData: DetailedView[]) {
		super();
		this.data = this.elementData;
	}
	connect(): Observable<DetailedView[]> {
		return Observable.of(this.data);
	}
	disconnect() { }
}



// WEBPACK FOOTER //
// ./src/app/plan-details/plan-details.component.ts